import Button from "@shared/v2/Button";
import Icon, { ArrowRightSolidV6 } from "@shared/v2/Icomoon";
import Modal from "@shared/v2/Modal";
import TextButton from "@shared/v2/TextButton";
import Typography from "@shared/v2/Typography";

interface PurchaseCompleteModalProps {
  open: boolean;
  onCancel: () => void;
  Icon: (props: typeof Icon) => JSX.Element;
  title: string;
  description: string;
  url: string;
}

const PurchaseCompleteModal: React.FC<PurchaseCompleteModalProps> = ({
  onCancel,
  open,
  Icon,
  title,
  description,
  url,
}) => (
  <Modal
    show={open}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    {/* @ts-expect-error props */}
    <Modal.Header />
    <Modal.Body className="tw-flex tw-flex-col tw-items-center">
      <div className="tw-flex tw-justify-center tw-items-center tw-flex-none tw-w-[75px] tw-h-[75px] tw-rounded-full tw-border-solid tw-border-[1px] tw-border-theme-primary">
        {/* @ts-expect-error props */}
        <Icon size="xxxl" className="tw-text-theme-primary" />
      </div>
      <div className="tw-text-[20px] tw-font-semibold tw-mt-[16px] tw-mb-[8px] tw-text-center tw-max-w-[270px]">
        {title}
      </div>
      {/* @ts-expect-error props */}
      <Typography className="tw-max-w-[320px] !tw-text-gray-50 tw-text-center">{description}</Typography>
      {/* @ts-expect-error props */}
      <Button size="medium" className="tw-mt-[32px]" onClick={() => window.location.assign(url)}>
        Get Started <ArrowRightSolidV6 />
      </Button>
      {/* @ts-expect-error props */}
      <TextButton size="medium" className="tw-mt-[12px]" onClick={onCancel}>
        Maybe Later
      </TextButton>
    </Modal.Body>
    {/* @ts-expect-error props */}
    <Modal.Footer />
  </Modal>
);

export default PurchaseCompleteModal;
